// PARAQTA · «Оқу пойызы» жалауы. 02.11 founder: БӘРІНЕ АШЫҚ. ?train=0 осы браузерде өшіреді (тексеру үшін), ?train=1 қайта қосады.
// index.html-дегі inline скрипт адрес қайта жазылмай тұрып ?train= мәнін localStorage-ке салады.
const DEFAULT_ON = true;
export function trainOn() {
  try {
    const q = (/[?&]train=([01])/.exec(location.href) || [])[1];
    if (q === '1') localStorage.setItem('pq_train', '1');
    if (q === '0') localStorage.setItem('pq_train', '0');
    const v = localStorage.getItem('pq_train');
    return v === '1' || (DEFAULT_ON && v !== '0');
  } catch { return DEFAULT_ON; }
}
